export default __webpack_public_path__ + "f5d59d142eafc9e6d943b6a4d4f743bb.png";